import { Component } from "react";
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { connect } from "react-redux";
import { createHChart } from "layouts/mainsection/components/CHighchartToolsTraffic";

class OETInvolucradasIncidente extends Component {
  componentDidMount() {}
  render() {
    //[{year: 2002, value: 10.5}]

    return this.props.data.series.length > 0 ? (
      <>
        {createHChart("chartMDOETInvolucradasIncidente", {
          chart: { type: "column" },
          title: {
            text: this.props.title,
          },
          xAxis: {
            title: {
              text: "Especies",
              enabled: false,
            },
            categories: this.props.data.categorias,
          },
          yAxis: {
            min: 0,
            title: {
              text: "Cantidad",
              enabled: false,
            },
          },
          // legend: { enabled: false },
          plotOptions: {
            series: {
              stacking: "percent",
            },
          },
          series: this.props.data.series.map((item) => {
            item.dataLabels = {
              enabled: true,
              align: "center",
              filter: {
                property: "percentage",
                operator: ">",
                value: 5,
              },
              format: "{point.percentage:.2f}%",
              // formatter: function (f)  { console.log(this, f); return `${f.percentage}`}, // one decimal
            };
            return item;
          }),
        })}
        <div style={{ fontSize: "0.9em" }}>
          <div className="has-text-centered" style={{ fontSize: "0.9em" }}>
            <p
              className="px-6"
              style={{
                color: "#000",
                fontSize: "1.1em",

                fill: "#000",
              }}
            >
              <i>{this.props.description}</i>
            </p>
          </div>
        </div>
      </>
    ) : null;
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(
  OETInvolucradasIncidente
);
